export function getLocalStorageItem(
  key: localStorageKeys,
  defaultValue: any,
): any | undefined {
  const value = localStorage.getItem(key);
  if (value === null) {
    return defaultValue;
  }
  return JSON.parse(value);
}

export function setLocalStorageItem(key: localStorageKeys, value: any): void {
  const json = JSON.stringify(value);
  localStorage.setItem(key, json);
}

export const API_HOST = 'api.host';
export const API_KEY = 'api.apiKey';
export const API_TAG_READ_SERVICE_ID = 'api.tagReadServiceId';
export const API_TAG_WRITE_SERVICE_ID = 'api.tagWriteServiceId';
export const API_VOTE_SERVICE_IDS = 'api.voteServiceIds';
export const API_ARCHIVE_IF_NOT_WORST = 'api.archiveIfNotWorst';
export const SETTINGS_ZOOM_ENABLED = 'settings.zoomEnabled';
export const SETTINGS_MOUSE_VOTES = 'settings.mouseVotes';
export const SETTINGS_THEME = 'settings.theme';
export const SETTINGS_TOOLBAR = 'settings.toolbar';
export const SETTINGS_TOOLBAR_TOP = 'settings.toolbar.top';
export const SETTINGS_TOOLBAR_BOTTOM = 'settings.toolbar.bottom';
export const SETTINGS_TOOLBAR_SETTINGS_BAR = 'settings.toolbar.settingsBar';
export const SETTINGS_TOP_BAR_VIS = 'settings.topBarVisibility';
export const SETTINGS_BOTTOM_BAR_VIS = 'settings.bottomBarVisibility';
export const SETTINGS_TOP_BAR_STYLE = 'settings.topBarStyle';
export const SETTINGS_BOTTOM_BAR_STYLE = 'settings.bottomBarStyle';
export const SETTINGS_SETTINGS_BAR_STYLE = 'settings.settingsBarStyle';
export const SETTINGS_SAVED_SEARCHES = 'settings.savedSearches';
export const SETTINGS_FAVORITE_TAGS = 'settings.favoriteTags';
export const SETTINGS_REDUCED_HISTORY_STEPS = 'settings.reducedHistorySteps';
export const SETTINGS_HISTORY_CHECKPOINT_SECONDS = 'settings.historyCheckpointSeconds';
export const SETTINGS_HISTORY_CHECKPOINT_IMAGES = 'settings.historyCheckpointImages';
export const SETTINGS_RECENT_TAGS = 'settings.recentTags';
export const SETTINGS_MAX_RECENT_TAGS = 'settings.maxRecentTags';
export const SETTINGS_PIXELATED_SCALE_MODE = 'settings.pixelatedScaleMode';
export const SETTINGS_ZOOM_PLAYBACK_SYNC = 'settings.zoomPlaybackSync';
export const SETTINGS_ARCHIVAL_MODE = 'settings.archivalMode';
export const SETTINGS_ARCHIVAL_RULES = 'settings.archivalRules';
export const SETTINGS_ALLOW_EXIT_WHILE_VOTING = 'settings.allowExitWhileVoting';
export const SETTINGS_CBOR_TRANSPORT_ENABLED = 'settings.cborTransportEnabled';
export const SETTINGS_FAVORITE_TAG_SORT_MODE = 'settings.favoriteTagSortMode';
export const SETTINGS_RECENT_HOSTS = 'settings.recentHosts';
export const SETTINGS_MAX_RECENT_HOSTS = 'settings.maxRecentHosts';
export const SETTINGS_RETRY_MAX_ATTEMPTS = 'settings.retryMaxAttempts';
export const SETTINGS_RETRY_INITIAL_DELAY = 'settings.retryInitialDelay';
export const SETTINGS_RETRY_AUTO_ENABLED = 'settings.retryAutoEnabled';

export type localStorageKeys =
  | typeof API_HOST
  | typeof API_KEY
  | typeof API_TAG_READ_SERVICE_ID
  | typeof API_TAG_WRITE_SERVICE_ID
  | typeof API_VOTE_SERVICE_IDS
  | typeof API_ARCHIVE_IF_NOT_WORST
  | typeof SETTINGS_ZOOM_ENABLED
  | typeof SETTINGS_MOUSE_VOTES
  | typeof SETTINGS_THEME
  | typeof SETTINGS_TOOLBAR
  | typeof SETTINGS_TOOLBAR_TOP
  | typeof SETTINGS_TOOLBAR_BOTTOM
  | typeof SETTINGS_TOOLBAR_SETTINGS_BAR
  | typeof SETTINGS_TOP_BAR_VIS
  | typeof SETTINGS_BOTTOM_BAR_VIS
  | typeof SETTINGS_TOP_BAR_STYLE
  | typeof SETTINGS_BOTTOM_BAR_STYLE
  | typeof SETTINGS_SETTINGS_BAR_STYLE
  | typeof SETTINGS_SAVED_SEARCHES
  | typeof SETTINGS_FAVORITE_TAGS
  | typeof SETTINGS_REDUCED_HISTORY_STEPS
  | typeof SETTINGS_HISTORY_CHECKPOINT_SECONDS
  | typeof SETTINGS_HISTORY_CHECKPOINT_IMAGES
  | typeof SETTINGS_RECENT_TAGS
  | typeof SETTINGS_MAX_RECENT_TAGS
  | typeof SETTINGS_PIXELATED_SCALE_MODE
  | typeof SETTINGS_ZOOM_PLAYBACK_SYNC
  | typeof SETTINGS_ARCHIVAL_MODE
  | typeof SETTINGS_ARCHIVAL_RULES
  | typeof SETTINGS_ALLOW_EXIT_WHILE_VOTING
  | typeof SETTINGS_CBOR_TRANSPORT_ENABLED
  | typeof SETTINGS_FAVORITE_TAG_SORT_MODE
  | typeof SETTINGS_RECENT_HOSTS
  | typeof SETTINGS_MAX_RECENT_HOSTS
  | typeof SETTINGS_RETRY_MAX_ATTEMPTS
  | typeof SETTINGS_RETRY_INITIAL_DELAY
  | typeof SETTINGS_RETRY_AUTO_ENABLED;
